import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges Tailwind classnames intelligently — handles conditional classes
 * via `clsx`, then resolves Tailwind conflicts (e.g. `p-2` + `p-4` →
 * `p-4`) via `tailwind-merge`. Use everywhere instead of raw
 * `className=` concatenation.
 *
 * @param  {...import('clsx').ClassValue} inputs
 * @returns {string}
 *
 * @example
 *   <button className={cn('px-4 py-2', isPrimary && 'bg-blue-500')} />
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
